<template>
    <div>
        <ams-base-chart chartTitle="Outcome Type By Primary Themes" :chartType="ChartTypes.BAR" :data="chartData" :stacked="true" />
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { toCapitalize } from '../../../../../../utilities';
import { ChartTypes } from '../../../../../../enums';
import { Colors } from '../../../../../../utilities/colors';

const props = defineProps({
    jsonData: {
        type: Array,
    },
});

const chartData = ref([]);

onMounted(() => {
    loadChartData();
});

const loadChartData = () => {
    chartData.value = props.jsonData
        ?.filter((item) => item.name != 'None')
        .map((data) => {
            return {
                label: toCapitalize(data.name),
                values: [
                    {
                        label: 'Local Issue',
                        bgcolor: Colors.BLUE,
                        value: data.outcomes?.filter((item) => item.name == 'Local Issue')?.map((item) => item.tot)[0] ?? 0,
                    },
                    {
                        label: 'Service Wide',
                        bgcolor: Colors.AMBER,
                        value: data.outcomes?.filter((item) => item.name == 'Service Wide')?.map((item) => item.tot)[0] ?? 0,
                    },
                    {
                        label: 'Notable Practice',
                        bgcolor: Colors.RED,
                        value: data.outcomes?.filter((item) => item.name == 'Notable Practice')?.map((item) => item.tot)[0] ?? 0,
                    },
                ],
            };
        });
};
</script>
